import React, { useState } from "react";
import { Scanner } from "@yudiel/react-qr-scanner";

const CategoryConversion = ({ onVerified }) => {
  const [barcode, setBarcode] = useState("");
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [showScanner, setShowScanner] = useState(true);

    const verifyAPI = async () => {
        try {
            // ALWAYS return success while dummy API
            const response = await new Promise((resolve) =>
            setTimeout(() => resolve({ data: { status: true } }), 500)
            );

            // Always call parent callback
            onVerified({
                barcode,
                mobile
            });

            setError("");

        } catch (err) {
            setError("Something went wrong.");
        }
    };


  // Reset scanner
  const scanAgain = () => {
    setBarcode("");
    setError("");
    setShowScanner(true);
  };

  return (
    <div style={styles.wrapper}>
      <h2 style={styles.title}>Barcode Verification</h2>

      {/* Scanner Box */}
      {showScanner ? (
        <div style={styles.scannerBox}>
          <Scanner
            onScan={(scanResult) => {
              if (scanResult && scanResult[0]) {
                setBarcode(scanResult[0].rawValue);
                setShowScanner(false); // Hide scanner after scan
              }
            }}
            styles={{ container: { width: "100%", height: "100%" } }}
          />
        </div>
      ) : (
        <button onClick={scanAgain} style={styles.scanAgainBtn}>
          🔄 Scan Again
        </button>
      )}

      {/* Form */}
      <div style={styles.form}>
        <label>Barcode</label>
        <input
          type="text"
          value={barcode}
          placeholder="Scanned barcode appears here"
          onChange={(e) => setBarcode(e.target.value)}
          style={styles.input}
        />

        <label>Mobile Number</label>
        <input
          type="text"
          value={mobile}
          maxLength={10}
          placeholder="Enter mobile number"
          onChange={(e) => setMobile(e.target.value)}
          style={styles.input}
        />

        <button onClick={verifyAPI} style={styles.button}>
          Verify
        </button>

        {/* Error */}
        {<p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
};

export default CategoryConversion;

// ------------------ Styles ------------------
const styles = {
  wrapper: {
    maxWidth: "500px",
    margin: "auto",
    padding: "20px",
    fontFamily: "Arial",
  },
  title: {
    textAlign: "center",
    marginBottom: "15px",
  },
  scannerBox: {
    width: "100%",
    height: "250px",
    borderRadius: "10px",
    overflow: "hidden",
    border: "2px solid #ddd",
    marginBottom: "20px",
  },
  scanAgainBtn: {
    width: "100%",
    padding: "10px",
    background: "#555",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    marginBottom: "20px",
    cursor: "pointer",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  input: {
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    width: "100%",
  },
  button: {
    padding: "10px",
    background: "#1976d2",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  success: {
    marginTop: "15px",
    padding: "10px",
    background: "#d4edda",
    borderRadius: "5px",
    color: "#155724",
  },
  error: {
    marginTop: "10px",
    color: "#d9534f",
    fontWeight: "bold",
  },
};
